import ApiService from "../../../commons/api/api_service";
import BaseResponse from "../../../commons/api/base_response";
import { Endpoints } from "../../../commons/api/endpoints";
import { ProviderVM } from "../../../commons/base/providers/view_model";
import { ShowErrorViewModel, ShowSnackbarModel } from "../../../commons/scaffold/scaffold";

export default class UploadMapCsvViewModel extends ProviderVM {
    isLoading: boolean = false;
    message: string = '';
    errorMessage: string = '';
    file?: File = undefined;
    week: number = 0;
    year: number = 0;
    showSnackbar?: ShowSnackbarModel;
    showErrorView?: ShowErrorViewModel;

    reset() {
        this.emit(() => {
            this.isLoading = false;
            this.errorMessage = '';
            this.file = undefined;
            this.year = 0;
            this.week = 0;
            this.showSnackbar = undefined;
            this.showErrorView = undefined;
        });
    }

    setFile(file: File) {
        this.emit(() => {
            this.file = file;
        });
    }

    setWeek(week: number) {
        this.emit(() => {
            this.week = week;
        });
    }

    setYear(year: number) {
        this.emit(() => {
            this.year = year;
        });
    }

    submit() {
        if (!this.file || this.file.type !== 'text/csv') {
            this.emit(() => {
                this.errorMessage = 'CSV file required';
                this.showErrorView = {
                    action: () => this.reset(),
                    message: this.errorMessage
                };
            });
            return;
        }

        if (this.week === 0 || this.year === 0) {
            this.emit(() => {
                this.errorMessage = 'Week and year required';
                this.showErrorView = {
                    action: () => this.reset(),
                    message: this.errorMessage
                }
            });
            return;
        }

        this.emit(() => {
            this.isLoading = true;
        });

        ApiService.uploadMapCsv<BaseResponse<{}>>(Endpoints.uploadMapWeeklyCsv, {
            data: {
                key: 'csv',
                file: this.file,
                week: this.week,
                year: this.year
            },
            onSuccess: (response) => {
                this.reset();
                this.showSnackbar = new ShowSnackbarModel({
                    message: `${response.message}`,
                    type: "info"
                });
            },
            onFailure: (error) => {
                this.reset();
                this.emit(() => {
                    this.isLoading = false;
                    this.errorMessage = `Error : ${error.response.data.message}`
                });
                this.showErrorView = {
                    action: () => this.reset(),
                    message: this.errorMessage
                }
            }
        });
    }
}
